import Arrow from "./component-library4.mjs";
import LinkButton from "./component-library3.mjs";
import "./component-library266.mjs";
import normalizeComponent from "./component-library95.mjs";
const _sfc_main = {
  name: "CompactItemInfo",
  components: { LinkButton, Arrow },
  props: {
    name: { type: String, required: true },
    activeVariants: { type: Array, required: true },
    position: { type: Number, required: true },
    isConfigurable: Boolean,
    isExtended: Boolean
  },
  emits: ["open-bundle-item-config"],
  computed: {
    actionLabel() {
      return this.isExtended ? "schließen" : "anpassen";
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "compact-item-info" }, [_c("div", { staticClass: "content" }, [_c("div", { staticClass: "primary-text" }, [_vm._v(" " + _vm._s(_vm.name) + " ")]), _c("div", { staticClass: "secondary-text" }, [_vm._v(" " + _vm._s(_vm.activeVariants.join(", ")) + " ")])]), _vm.isConfigurable ? _c("LinkButton", { staticClass: "action", attrs: { "tag": "button", "text": "" }, on: { "click": function($event) {
    return _vm.$emit("open-bundle-item-config", { position: _vm.position });
  } } }, [_vm._v(" " + _vm._s(_vm.actionLabel) + " "), _c("Arrow", { staticClass: "action__icon", attrs: { "tag": "span", "direction": _vm.isExtended ? "top" : "bottom" } })], 1) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "c5cd31ab",
  null,
  null
);
const CompactItemInfo = __component__.exports;
export {
  CompactItemInfo as default
};
